import { api } from '@leroy-merlin-br/backpack-services'
import Cookies from 'js-cookie'

api.defaults.baseURL = window.env.baseHost

api.interceptors.request.use(
  (request) => {
    const API_TOKEN = Cookies.get('api_token')

    if (API_TOKEN) {
      request.headers.Authorization = `Bearer ${API_TOKEN}`
    }

    return request
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default api
